import React, { useEffect, useState } from 'react'
import { IconPlus, IconPencil, IconTrash, IconDotsVertical, IconSettings } from "@tabler/icons-react";
import { useAuth } from '../../Context/store/context';
import globals from '../../../globals';
import { NavLink, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';
import { servicesList } from '../../Redux/Actions/ServicesListAction';
import { _delete, _get, _put } from '../../../apiClient';
import { _showToast } from '../../../toastHelper';




const filteredData2 = [
  {
    title:"wedding photography",
    Servicedescription:"we do all types of wedding photography works",
    serviceId:1
    },
  {
    title:"birthday photography",
    Servicedescription:"we do birthday photography works",
    serviceId:2
    },
  {
    title:"gift articles",
    Servicedescription:"we have all types of wedding and all events gift articles with us",
    serviceId:3
    },
  {
    title:"wditing services",
    Servicedescription:"we do all types of editing works",
    serviceId:4
    },
]

export default function MyServices() {

  const services = useSelector((state) => state.servicesList.servicesList);
  const userDetails = useSelector((state) => state.admininfo.admininfo);
  const [isInitialLoading, setInitialLoading] = useState(true);
  const [searchQuery, setSearchQuery] = useState('');
  const { showLoader, hideLoader, updateTitleAndIcon, getToken, logoutuser } = useAuth();
  const [filteredData, setFilteredData] = useState([]);

  const Navigate = useNavigate();
  const dispatch = useDispatch();


  useEffect(() => {
    if (!getToken())
      logoutuser();
    updateTitleAndIcon(globals.myservices.title, globals.myservices.icon);
  }, []);



  useEffect(() => {

    if (userDetails && isInitialLoading && services.length == 0) {
      fetchServicesList();
    }

    filterData();

  }, [services, userDetails])





  const fetchServicesList = async () => {
    showLoader();
    setInitialLoading(false);
    await _get('/app-user-services')
      .then((response) => {
        dispatch(servicesList(response));
        hideLoader();
      })
      .catch((error) => {
        hideLoader();
        _showToast(error, "error");
      });
  }



  useEffect(() => {
    filterData();
  }, [searchQuery]);



  const filterData = () => {
    if (searchQuery === '') {
      setFilteredData(services);
    } else {
      const filtered = services.filter(service => {
        const servicesTitle = service.serviceName?.toLowerCase() ?? '';
        const serviceDescription = service.description?.toLowerCase() ?? '';
        // const contactNo = profile.contactNo?.toLowerCase() ?? '';

        return (
          servicesTitle.includes(searchQuery.toLowerCase()) ||
          serviceDescription.includes(searchQuery.toLowerCase()) 
          // contactNo.includes(searchQuery.toLowerCase())
        );
      });
      setFilteredData(filtered);
    }
  }


  const addProfile = () => {
    return Navigate("/services/add");
  }


  const editProfile = (serviceId) => {
    return Navigate("/services/edit/" + serviceId);
  }



const deleteProfile = async (serviceId) => {
    const confirmation = window.confirm(
      "Are you sure you want to delete this? This action cannot be undone."
    );

    if (confirmation) {
      showLoader();
      await _delete(`/app-user-services/${serviceId}`)
        .then((response) => {
          _showToast("Selected service deleted successfully", "success");
          fetchServicesList();
        })
        .catch((error) => {
          hideLoader();
          _showToast(error, "error");
        });
    }

  }

  return (
  <div className='content-wrapper '>
    
  <div className="container-xxl flex-grow-1 container-p-y">
        <div className="row">
          <div className="col-12 mb-4">
            <div className="card mb-3">
              <div className="card-body">
              <div className="d-flex flex-lg-row  justify-content-between align-items-md-center gap-1">
                  <div style={{ width: "375px" }}>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Search By Service Name"
                      aria-label="Search for service..."
                      value={searchQuery}
                      onChange={(e) => setSearchQuery(e.target.value)}
                    />
                  </div>
                  <div>
                    <button className="btn btn-primary px-2" 
                    onClick={addProfile} 
                    >
                      <IconPlus size={20} className='me-1' />
                      <span className="align-middle">Add</span>
                    </button>
                  </div>
                </div>
              </div>
              </div>


              <div className="card">
              <div className="card-datatable  pt-0">
                <div id='example_wrapper' className='dataTables_wrapper dt-bootstrap5 no-footer pt-4'>
                  <div className='row dt-row'>
                    <div className='col-sm-12'>
                      <table id="example" className=" table rwd-table">
                        <thead>
                          <tr>
                            <th>S.No</th>
                            <th>Title</th>
                            <th>description</th>
                            {/* <th>Phone</th> */}
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {filteredData && filteredData.length > 0 && filteredData.map((data, index) => (
                            <tr key={index}>
                              <td>{index + 1}</td>
                              <td>
                                <div className="d-flex justify-content-start align-items-center user-name">
                                  <div className="avatar-wrapper">
                                    <div className="avatar me-2">
                                      <img src={data.logo || "/images/user3.png"} alt="Avatar" className="rounded-circle" />
                                    </div>
                                  </div>
                                  <div className="d-flex flex-row ">
                                    <span className="emp_name text-truncate">{data.serviceName}</span>
                                  </div>
                                </div>
                              </td>
                              <td data-th="E-mail Id">{data.description}</td>
                              {/* <td data-th="Phone">{data.contactNo}</td> */}
                              <td data-th="Actions">
                                <div className="dropdown" data-bs-toggle="dropdown">
                                  <div>
                                    <a className='cursor-pointer'><IconDotsVertical size={22} />
                                    </a>
                                  </div>
                                  <div role="menu" aria-hidden="false" className="dropdown-menu" data-popper-placement="bottom-start">
                                    {/* <a title="Edit" role="menuitem" className="dropdown-item cursor-pointer" onClick={() => setAsPrimaryHandler(data.id)}>
                                      <IconSettings size={19} className='me-1' />Set As Primary
                                    </a> */}
                                    <a title="Edit" role="menuitem" className="dropdown-item cursor-pointer" onClick={() => editProfile(data.id)}>
                                      <IconPencil size={19} className='me-1' />Edit
                                    </a>
                                    <a title="Delete" role="menuitem" className="dropdown-item cursor-pointer text-danger" onClick={() => deleteProfile(data.id)}>
                                      <IconTrash size={19} className='me-1' />Delete
                                    </a>
                                  </div>
                                </div>
                              </td>
                            </tr>
                          ))}
                          {filteredData && filteredData.length == 0 && (
                            <tr>
                              <td colSpan={6} style={{ textAlign: "center", border: "0" }}><h5 style={{ marginTop: "1rem" }}>No Data Available</h5></td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
              </div>
              </div>
              </div>
  </div>
  )


}
